import { useState } from "react";
import { Accordion, Card, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleExclamation, faTriangleExclamation, faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import Loading from "../../utils/Loding";
import { ClinkFromServer } from "../../utils/types";

interface ExistingClinksTableProps {
  existingCLinks: ClinkFromServer[];
  isLoading: boolean;
}

const cardHeaderStyle = {
  fontWeight: "bold",
  fontSize: "1.2rem",
  cursor: "pointer",
  display: "flex"
}

function ExistingClinksTable(props:ExistingClinksTableProps) {
  const { existingCLinks, isLoading } = props;
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  if (isLoading) return <Loading />;

  const handleModeViewChange = () => {
    setIsAccordionOpen(!isAccordionOpen);
  }
  const isDailyCapForCLink = (clink:ClinkFromServer) => {
	  return ( clink.configs && clink.configs.length > 0 && clink.configs[0].daily_cap && clink.configs[0].daily_cap > 0 );
  };

  return (
    <Card>
      <Accordion activeKey={isAccordionOpen ? 'existingClinks' : ''}>
        <Accordion.Toggle as={Card.Header} eventKey="existingClinks" onClick={() => handleModeViewChange()} style={cardHeaderStyle}>
          <FontAwesomeIcon style={{ fontSize: "1.6rem"}} icon={isAccordionOpen ? faCaretDown : faCaretUp} />
          <span style={{ marginLeft: "0.5rem" }}>
            Existing cLinks for Product ({existingCLinks.length}) 
          </span>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="existingClinks">
          <Card.Body>
            <Table style={{ fontSize: 11 }} responsive striped bordered hover>
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Traffic Sources</th>
                  <th>cLink ID</th>
                  <th>Sources</th>
                  <th>Platform</th>
                  <th>Countries</th>
                  <th style={{ textAlign: "right" }}>Payout</th>
                  <th style={{ textAlign: "right" }}>DailyCap</th>

                  <th style={{ textAlign: "right" }}>Clicks</th>
                  <th style={{ textAlign: "right" }}>Conv.</th>
                  <th style={{ textAlign: "right" }}>CR</th>
                </tr>
              </thead>
              <tbody>
                {
                  existingCLinks.sort((a, b) => a.stats.weekBuys < b.stats.weekBuys ? 1 : -1).map((clink:ClinkFromServer, index:number) => {
                    return (
                      <tr key={index}>
                        <td>
                          <div title={"Health - " + clink.health} style={{ display: "inline-block", marginRight: "0.5rem" }}>
                            {(() => {
                              if (clink.health === 'Green') {
                                return <FontAwesomeIcon icon={faCircleCheck} style={{color: "#5cb85c"}}/>
                              } else if (clink.health === 'Red') {
                                return <FontAwesomeIcon icon={faCircleExclamation} />;
                              } else {
                                return <FontAwesomeIcon icon={faTriangleExclamation} style={{color: "#ed9c28"}} />;
                              }
                            })()}
                          </div>
                          {clink.configs[0].status}
                        </td>
                        <td title={clink.pub_name}>{clink.pub_name}</td>
                        <td title={clink.clink_id} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", paddingRight: "12px"}}>{clink.clink_id}</td>
                        <td>
                          {
                            clink.configs[0].campaigns.map((campaign:any, campaignIndex:number) => {
                              return (
                                <div key={campaignIndex}>{campaign.source}</div>
                              );
                            })
                          }
                        </td>
                        <td>
                          <span title={clink.configs[0].platforms}>
                            {clink.configs[0].platforms}
                          {/* <platform platforms="clink.configs[0].platforms"></platform> */}
                          </span>
                        </td>
                        <td style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>
                          <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", paddingRight: "12px"}} title={clink.configs[0].countries}>
                            {clink.configs[0].countries}
                          </span>
                        </td>
                        <td style={{ textAlign: "right" }}>{clink.configs[0].p2p}</td>
                        <td style={{ textAlign: "right" }}>
                          {
                            isDailyCapForCLink(clink) ? <span>{clink.configs[0].daily_cap}</span> : null
                          }
                        </td>      
                        <td style={{ textAlign: "right" }}>
                          {clink.stats.weekBuys}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {clink.stats.weekInstalls.toLocaleString()}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {
                            (clink.stats.weekBuys > 0) ? <span>{(clink.stats.weekInstalls / clink.stats.weekBuys).toLocaleString('en-US', { style: 'percent' })}</span> : null
                          }
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </Table>
          </Card.Body>
        </Accordion.Collapse>
      </Accordion>
    </Card>
  );
}
export default ExistingClinksTable;